import React from "react";
import { FiSearch, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./no-search-results.css";

export default function NoSearchResults({ onReset } = {}) {
  const navigate = useNavigate();

  return (
    <main className="no-search-page">
      <img className="no-search-logo" src={logo} alt="Hallef Technologies" />
      <section className="no-search-card" aria-labelledby="no-search-title">
        <div className="no-search-icon"><FiSearch aria-hidden="true" /></div>
        <p className="no-search-eyebrow">SEARCH HALLEF</p>
        <h1 id="no-search-title">No results found</h1>
        <p className="no-search-description">
          We couldn't find anything matching your search. Try different keywords or check your spelling.
        </p>
        <button className="no-search-back" type="button" onClick={onReset || (() => navigate(-1))}>
          <FiArrowLeft aria-hidden="true" /> {onReset ? "Clear filters" : "Go back"}
        </button>
      </section>
      <p className="no-search-footer">Hallef Technologies <span aria-hidden="true">&middot;</span> Search support</p>
    </main>
  );
}
